import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fmtEuroCents } from "@/lib/format";
import { TrendingUp } from "lucide-react";

const d = (s) => new Date(s).toLocaleDateString("el-GR");

export const PriceAlerts = ({ year }) => {
  const [all, setAll] = useState(false);
  const { data } = useQuery({ queryKey: ["erp-price-alerts", year], queryFn: async () => (await api.get(`/erp/price-alerts?year=${year}&threshold=10`)).data });
  const list = data?.alerts || [];
  const shown = all ? list : list.slice(0, 8);
  return (
    <div className="rounded-2xl bg-white border border-[#E3DED4] overflow-hidden" data-testid="bs-price-alerts">
      <div className="px-5 pt-4 pb-2 flex items-center justify-between gap-3">
        <h2 className="font-medium text-[#45423C] flex items-center gap-2">
          <TrendingUp className="h-4 w-4 text-[#B5452F]" /> Αυξήσεις τιμών πάνω από 10%
          <span className="rounded-full bg-[#F6E3DC] text-[#B5452F] text-xs px-2 py-0.5" data-testid="bs-price-alerts-count">{list.length}</span>
        </h2>
        {list.length > 8 && (
          <button data-testid="bs-price-alerts-toggle" onClick={() => setAll(!all)} className="text-sm font-semibold text-[#6E7A63] hover:underline">
            {all ? "Λιγότερα" : `Όλες (${list.length})`}
          </button>
        )}
      </div>
      {list.length === 0 ? (
        <p className="px-5 pb-4 text-sm text-[#6F6A60]" data-testid="bs-price-alerts-empty">Καμία αύξηση πάνω από 10% για το {year}.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F3F0EA] text-[10px] uppercase tracking-wider text-[#6F6A60]">
              <tr><th className="px-3 py-2 text-left">Είδος</th><th className="px-3 text-left">Προμηθευτής</th><th className="px-3 text-right">Προηγούμενη</th><th className="px-3 text-right">Νέα</th><th className="px-3 text-right">Αύξηση</th></tr>
            </thead>
            <tbody>
              {shown.map((a) => (
                <tr key={a.key} className="border-t border-[#E3DED4]" data-testid="bs-price-alert-row">
                  <td className="px-3 py-2 font-medium text-[#45423C]">{a.item}</td>
                  <td className="px-3 text-xs text-[#6F6A60] max-w-[220px] truncate" title={a.supplier}>{a.supplier}</td>
                  <td className="px-3 text-right tabular whitespace-nowrap">{fmtEuroCents(a.prev_price)}<div className="text-[11px] text-[#6F6A60]">{d(a.prev_date)}</div></td>
                  <td className="px-3 text-right tabular whitespace-nowrap">{fmtEuroCents(a.price)}<div className="text-[11px] text-[#6F6A60]">{d(a.date)}</div></td>
                  <td className="px-3 text-right tabular font-semibold text-[#B5452F]">+{a.change_pct}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
